// function isInternetExplorer() {
// 	var ua = window.navigator.userAgent;
// 	var msie = ua.indexOf("MSIE ");
// 	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) return true;
// 	return false;
// }
// if(isInternetExplorer()){
// 	window.location = '/ie';
// }

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
	window.Popper = require('popper.js').default;
	window.$ = window.jQuery = require('jquery');

	require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.moment = require('moment');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// CSRF
// let token = document.head.querySelector('meta[name="csrf-token"]');
// if (token) {
// 	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// } else {
// 	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
// }

// Public Base

let publicBaseMTag = document.head.querySelector('meta[name="public-base"]');
if (publicBaseMTag) {
	window.publicBaseUrl = publicBaseMTag.content;
} else {
	console.error('Public Base not defined');
}

// API Base

let apiBaseMTag = document.head.querySelector('meta[name="api-base"]');
if (apiBaseMTag) {
	window.apiBaseUrl = apiBaseMTag.content;
} else {
	console.error('API Base not defined');
}